module.exports = __webpack_public_path__ + "static/media/texture (38).f1bdbbaa.jpg";